<template>
  <div>
    <h5>Подтверждение доавление клиента в систему PAYMART{{ order.client.phone }}</h5>
    <br />
    <br />
    <div class="install-control">
      <button @click="next" class="btn btn-success">{{ 'next_step' | setText('Далее') }}</button>
    </div>
  </div>
</template>
<script>
import { logger } from '../../../plugins/functions';

export default {
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    index: {
      default: 0
    },
    hash: {
      default: null
    }
  },
  name: "filter",
  async created() {

  },
  methods: {

    next() {
      this.save();
    },
    prev() {
      this.$emit('next', this.index - 1);
    },
    save() {
      this.$loading(true);

      logger(this.$http, {
        name: 'Добавление клиента в #PAYMART',
        description: 'Начало запроса',
        model_type: 'order',
        model_id: this.order.id
      });

      this.$http
        .post(`${this.partner['endpoint_url']}partner/buyers/add`,
          {
            phone: this.order.client.phone,
            step: 1
          },
          {
            headers: {
              'Authorization': `Bearer ${this.partner['api_secret_key']}`,
              'Content-Type': 'application/json'
            }
          })
        .then((response) => {
          if (response.data) {
            switch (response.data.status) {
              case 'success':
                this.$emit('getBuyer', response.data.data.id);
                this.message = 'Клиент добавлен';
                setTimeout(() => {
                  this.$emit('next', 4);
                }, 10);
                break;
              default:
                this.message = 'Неизвестная ошибка от PAYMART';
                break;
            }

            logger(this.$http, {
              name: 'Добавление клиента в #PAYMART',
              description: this.message,
              model_type: 'order',
              model_id: this.order.id
            });

            this.$notify({
              title: "PAYMART",
              message: this.message,
              icon: "ti-save",
              horizontalAlign: "right",
              verticalAlign: "top",
            });

          }


        })
        .catch((error) => {

          logger(this.$http, {
            name: 'Добавление клиента в #PAYMART',
            description: 'Ошибка системы #PAYMART',
            model_type: 'order',
            model_id: this.order.id
          });

          alert('Ошибка партнера');
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  data() {
    return {
      code: null,
      message: ''
    };
  },
};
</script>
<style lang="scss">

</style>
